import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { VERTICAL_VIDEO_CARD_CONTAINER } from 'src/shared/static';
import { C42VerticalVideoCardFields } from './C42VerticalVideoCard.types';

export type C42VerticalVideoGalleryProps = RenderingProps<
  C42VerticalVideoGalleryFields,
  C42VerticalVideoGalleryParams,
  C42VerticalVideoGalleryPlaceholders
>;

export type C42VerticalVideoGalleryFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  Cta?: LinkField;
};

export type C42VerticalVideoGalleryPlaceholders = {
  [VERTICAL_VIDEO_CARD_CONTAINER]?: Array<{
    fields?: C42VerticalVideoCardFields;
  }>;
};

export type C42VerticalVideoGalleryParams = {
  HeadlineTag?: string;
  CtaStyle?: string;
  BackgroundColor?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
